@if (help) {
  <span
    class="span"
    [pTooltip]="!extended() ? help : ''"
    [tooltipStyleClass]="!extended() && help.length > 100 ? 'is-wider' : ''"
    [tooltipPosition]="tooltipPosition()"
    (mouseleave)="handleMouseLeave(300)"
    (mouseenter)="extended() ? opRef.show($event) : null">
    <i
      class="pi pi-info-circle h-5.25 w-5.25 text-(--icon-on-subtle) text-(length:--icon-size-l) cursor-help [transition:color_300ms] hover:text-(--text-primary-color)"></i>
  </span>
}
<p-popover styleClass="form-field-help-popover" #opRef>
  <ng-template #content>
    <div
      class="p-6 w-full max-w-75 max-h-[60vh] overflow-y-auto overscroll-contain"
      (mouseenter)="mouseOnOverlay = true; opRef.show($event)"
      (mouseleave)="mouseOnOverlay = false; handleMouseLeave()"
      [innerHTML]="help"></div>
  </ng-template>
</p-popover>
